const messageSet = {
    unhandledMessage: 'Oops, something went wrong',
};

export default messageSet;
